var quickviewmode = '';

function quickviewafter(cls)
{
  allsizes = null;
  $(".selector-wrapper").after("<label id='sizelabel'>SIZES <span class='fit'>| Size Chart</span></label>");
  goColorDropdownGetSizesPre($("select[data-option='option1']").val(),true);
    
  $('.opt-container').on('click', function(){
    $('.opt-container').removeClass('selected');
    $(this).addClass('selected');
  });
  
     setTimeout(function() {  //please remove the setTimeout, figure out when the select is loaded
        $("select[data-option='option1']").on('change', function(){
          	  $("#colorspan").html($("span.currentSwatch").data("name"));
              goColorDropdownGetSizesPre($(this).val(),true);
        });
        //$(".selector-wrapper").after("<label id='sizelabel'>SIZES <span class='fit'>| Size Chart</span></label>");
		$("label:contains('COLOR')").html('COLORS <span>| </span><span id="colorspan"></span>');
        $("#colorspan").html($("span.currentSwatch").data("name"));
        goColorDropdownGetSizesPre($("select[data-option='option1']").val(),true);
       }, 1000);  

  if (cls.indexOf('singlecolor') > -1)
  {
    quickviewmode = 'singlecolor';
   	$(".webyzeSwatches").hide();
	$("label:contains('Color')").hide();
  }
  addtocarthandler();
}

function quickviewafterONLYFORONECOLOR()
{
  $("img." + globalcolor.replace(" ","_")).click();
  $("select[data-option='option1']").val(globalcolor);
  $("select[data-option='option1']").hide();
  $("#prod-room").hide();
  $("label:contains('COLOR')").text('SIZE');
  $("label:contains('Title')").text('SIZE');
  goColorDropdownGetSizesPre($("select[data-option='option1']").val(),true);
}
